import { v4 } from 'uuid'
import { getImageUrlFromName } from '../../../util'

const StayTipsLayout = ({ layout, value }) => {
  let imageUrl = getImageUrlFromName(layout.icon_name)

  return (
    <div
      style={{
        padding: '16px 20px 32px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#00ff00',
      }}
    >
      <div>
        <img src={imageUrl} alt="" style={{ width: '100px', height: 'auto' }} />
      </div>
      <div
        style={{
          marginTop: '16px',
          marginBottom: '32px',
          textAlign: 'left',
          color: 'var(--gray100)',
        }}
      >
        <p className="title2">{layout.display_name}</p>
      </div>
      <ul
        style={{
          padding: '0 20px 0 20px',
        }}
      >
        {value.map((item) => {
          return (
            <li
              style={{
                textAlign: 'left',
                color: 'var(--gray100)',
                lineHeight: '150%',
                margin: '24px 0px',
              }}
              key={v4()}
            >
              <p className="body2">{item}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default StayTipsLayout
